import React from 'react';

import style from './Article.scss';

import cn from 'classnames';

interface IArticleProps {
  className?: string;
  html: string;
}

export const Article = (props: IArticleProps) => (
  <article className={cn(props.className, style.article)}>
    <div className="container">
      <div className="row">
        <div className="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
          <section dangerouslySetInnerHTML={{ __html: props.html }} />
        </div>
      </div>
    </div>
  </article>
);
